// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1PWkB","field":"styles_field__377wo","fieldCol":"styles_fieldCol__1Dop9","diffCol":"styles_diffCol__2Y4xi","diff":"styles_diff__1bwlC"};